import React, { useState, useRef } from 'react';
import {
  ProductPage,
  ProductContainer,
  ProductHeader,
  SwipeContent,
  SlideText,
  SlideImage,
} from './ProjectElements';

import { Models } from './Data';
import './ProjectStyle.css';

import { useLanguage } from '../../../hooks';
import { MainPageText } from '../../Library/LibraryMainPage';

import { Swiper, SwiperSlide, Navigation } from '../../shared/Swiper';
import { CustomPagination } from '../../shared/CustomPagination/index';

const ProjectsSection = () => {
  const { lang } = useLanguage();
  const swiperRef = useRef(null);

  // activeIndex tracks the current dot, totalDots tracks how many views exist
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalDots, setTotalDots] = useState(0);

  const handleDotClick = (index) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiper = swiperRef.current.swiper;
      // multiplying the requested dot index by the current group parameter
      // computes the exact array index of the first slide in that specific view!
      const targetSlideIndex = index * swiper.params.slidesPerGroup;
      swiper.slideTo(targetSlideIndex);
    }
  };

  return (
    <ProductPage id="project">
      <ProductContainer>
        <ProductHeader>{MainPageText[lang]?.project || 'Projects'}</ProductHeader>

        <Swiper
          ref={swiperRef}
          spaceBetween={30}
          navigation={true}
          modules={[Navigation]}
          className="mySwiper"
          // we use swiper's native event hooks to dynamically read the calculated grid layout
          onInit={(swiper) => {
            setTotalDots(swiper.snapGrid.length);
            setActiveIndex(swiper.snapIndex);
          }}
          onResize={(swiper) => {
            // recalculates how many dots exist when the user resizes the window
            setTotalDots(swiper.snapGrid.length);
          }}
          onSlideChange={(swiper) => {
            // snapIndex specifically tracks the current discrete "view" rather than the node index
            setActiveIndex(swiper.snapIndex);
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              slidesPerGroup: 1, // translates 1 item at a time
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2, // translates a full visual block of 2 items
              spaceBetween: 30,
            },
            1200: {
              slidesPerView: 3,
              slidesPerGroup: 3, // translates a full visual block of 3 items
              spaceBetween: 40,
            },
          }}
        >
          {Models.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="slide-inner">
                <SwipeContent to={item.link}>
                  <SlideImage src={item.image} alt="project image" />
                  <SlideText>{item.text[lang]}</SlideText>
                </SwipeContent>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <CustomPagination
          totalItems={totalDots}
          activeIndex={activeIndex}
          onDotClick={handleDotClick}
        />
      </ProductContainer>
    </ProductPage>
  );
};

export default ProjectsSection;
